export default __webpack_public_path__ + "media/images/avatars/avatar6-3c63567386673f08fdf9b8ac081a4bad.png";